import React from "react";

const Checkbox = ({
  checked = false,
  onChange,
  id,
  name,
  disabled = false,
  className = "",
}) => {
  return (
    <label
      className={`inline-flex flex-none items-center select-none ${
        disabled ? "cursor-not-allowed" : "cursor-pointer"
      } ${className}`}
    >
      <input
        type="checkbox"
        className="sr-only pointer-events-none"
        checked={checked}
        onChange={onChange || (() => {})}
        onClick={(e) => e.stopPropagation()}
        disabled={disabled}
        id={id}
        name={name}
        tabIndex={-1}
      />
      <span
        className={`flex-none w-5 h-5 rounded-[6px] flex items-center justify-center text-[12px] font-bold text-white border-[1.5px] border-solid transition-all duration-150 ${
          disabled ? "cursor-not-allowed" : "cursor-pointer"
        } ${
          checked
            ? "bg-brand-purple border-brand-purple"
            : "bg-white !border-[1.5px] !border-solid !border-border-badge"
        }`}
      >
        {checked && "✓"}
      </span>
    </label>
  );
};

export default Checkbox;
